import s from '@components/Cards/PaymentHistoryItem/paymentHistoryItem.module.scss';
import { SpriteIcon, SpriteIconProps, SpriteIconsKeys } from '@components/Sprites/SpriteIcon';
import React, { FC } from 'react';
import { purchase } from '@prisma/client';
import { SocialManagerView, Toy } from '@specs/views';
import { getIconName, excludedPurchaseTypes } from '@services/payments/helpers/history';
import { PurchaseTypes } from '@specs/specs';
import { Avatar } from '@components/UIKit/Avatar/Avatar';
import { OptimizedImage } from '@components/OptimizedImage/OptimizedImage';
interface Props {
  type: excludedPurchaseTypes;
  currency: purchase['currency'];
  provider: purchase['provider'];
  toy: Toy.Single | null | undefined;
  referralProfile: SocialManagerView.publicProfile | null | undefined;
  isMy: boolean;
  isPositive: boolean;
}
const defaultIconProps = {
  className: s.paymentHistoryItem__icon,
  width: 32,
  height: 32
} satisfies Omit<SpriteIconProps, 'name'>;
export const PaymentHistoryImage: FC<Props> = ({
  type,
  currency,
  provider,
  toy,
  isMy,
  isPositive,
  referralProfile
}) => {
  const name = getIconName(type, currency, isPositive, isMy); // TODO: isMY не передаются сюда и не используется в функции

  return <>
            {name ? <SpriteIcon {...defaultIconProps} name={type === PurchaseTypes.SOCIAL_VERIFICATION && !!provider ? provider as SpriteIconsKeys : name} /> : type === PurchaseTypes.REFERRAL && !!referralProfile ? <Avatar srcSet={[{
      width: 32,
      height: 32,
      minMedia: 0
    }]} profile={referralProfile} isLoading={false} /> : toy ? <OptimizedImage boxClassName={s.paymentHistoryItem__icon} path={'/toys/cards'} cdnId={toy.imageid} alt={toy.name} fill /> : <SpriteIcon {...defaultIconProps} name={'avatar_default'} />}
        </>;
};